import { NfStatus } from './nf-status.enum';

export interface NfSearchFilter {
  statuses: NfStatus[];
  searchText: string | null;
  createdOnStart: string | null;
  createdOnEnd: string | null;
}

export interface NfSearchRequest {
  page: number;
  size: number;
  filter: NfSearchFilter;
}

export const NF_LIST_DEFAULT_PAGE_SIZE = 20;
